import mwcMarketsCore from 'mwc-markets-core';
import Component from './src/cryptocurrency.vue';

const { createCustomElement } = mwcMarketsCore;

export default createCustomElement(Component);
